import React from 'react';
import Footer from './common/Footer';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 relative overflow-hidden">
     

      <div className="flex-grow flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8">
        {/* Logo Section */}
        <div className="w-full max-w-lg mb-8">
          <div className="flex flex-col items-center relative z-10">
            <img
              src="/images/imr-logo.png"
              alt="IMR Logo"
              className="h-32 w-auto mb-4"
            />
            <h1 className="text-center text-2xl font-bold text-yellow-500">
              DEFENCE INDUSTRY DIRECTORY
            </h1>
          </div>
        </div>

        {/* Terms Content */}
        <div className="w-full max-w-4xl relative z-10">
          <div className="bg-gray-800/90 shadow-lg rounded-lg p-8 border border-gray-700 backdrop-blur-sm text-gray-300">
            <h2 className="text-2xl font-bold text-yellow-500 mb-6">Terms of Use</h2>
            <p className="text-sm mb-4">Effective Date: 1 June 2025</p>
            
            <p className="mb-6">
              Welcome to directory.defencepartners.in. (https://directory.defencepartners.in) ("the Website"). 
              By accessing or using this Website, you agree to comply with and be bound by the following Terms of Use. 
              Please read them carefully before using our services.
            </p>

            <div className="space-y-6">
              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">1. Acceptance of Terms</h3>
                <p>By accessing or using this Website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use and our Privacy Policy. If you do not agree, please do not use the Website.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">2. Service Description</h3>
                <p>This Website provides a searchable directory of defense companies and defense-related products & services for paid subscribers. The information is intended for general reference only.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">3. General Disclaimer</h3>
                <p>Every effort is made to ensure the accuracy and reliability of the information presented. However, due to the dynamic nature of the industry, we cannot guarantee that all details are current or correct at all times. Users should independently verify any information before acting upon it. We disclaim any liability for losses, damages, or inconveniences resulting from the use of this directory.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">4. Limitation of Liability</h3>
                <p>While we strive for accuracy and completeness, changes may occur without notice. Users must conduct their own due diligence. We are not responsible for errors, omissions, or financial losses resulting from reliance on the information provided.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">5. Verification Advisory</h3>
                <p>The data in this directory is compiled with care. However, users are urged to verify details directly with the respective entities. We accept no liability for inaccuracies or actions taken based on the information provided.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">6. Subscription and Access</h3>
                <p>Access to certain features and information is restricted to paid subscribers. You are responsible for maintaining the confidentiality of your account and subscription details.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">7. Intellectual Property</h3>
                <p>All content, including text, graphics, logos, and data compilations, is the property of IMR Media Pvt Ltd or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our written permission.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">8. Prohibited Conduct</h3>
                <p>You agree not to:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Use the Website for unlawful purposes.</li>
                  <li>Attempt to gain unauthorized access to any part of the Website.</li>
                  <li>Use automated systems to extract data ("scraping") without our consent.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">9. Modifications to Terms</h3>
                <p>We reserve the right to update or modify these Terms of Use at any time. Changes will be effective upon posting. Continued use of the Website constitutes acceptance of the revised terms.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">10. Governing Law</h3>
                <p>These Terms are governed by the laws of India. Any disputes arising from these Terms or the use of the Website will be subject to the exclusive jurisdiction of the courts in India.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">11. Contact Us</h3>
                <p>For questions or concerns about these Terms, please contact us at directory@defencepartners.in.</p>
              </section>

              <p className="mt-8 text-sm text-gray-400">
                By using this Website, you acknowledge that you have read, understood, and agree to these Terms of Use.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;
